<template>
  <v-layout>
    <v-col v-if="User.isForm" cols :sm="12" class="pa-0">
      <v-form v-model="User.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.user") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field color="primary" v-model="User.obj.name" readonly>
                  <template #label>
                    {{ $t(`table.name`) }}
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-datePicker v-model="User.obj.birthday" readonly birthday />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-gender v-model="User.obj.gender" readonly />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-province v-model="User.obj.province" readonly />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-row>
                  <v-col cols :sm="4" class="py-0">
                    <v-upload
                      :size="120"
                      class="mb-3"
                      :label="$t(`table.avatar`)"
                      v-model="User.obj.avatar"
                      readonly
                    />
                  </v-col>
                  <v-col cols :sm="4" class="py-0">
                    <v-upload
                      :size="120"
                      class="mb-3"
                      :label="$t(`table.cover`)"
                      v-model="User.obj.backgroundImage"
                      readonly
                    />
                  </v-col>
                  <v-col cols :sm="4" class="py-0">
                    <v-upload
                      :size="120"
                      class="mb-3"
                      :label="$t(`table.datingImages`)"
                      :images="User.obj.datingImages.map((e) => e.link)"
                      readonly
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols :sm="4" class="pt-5">
                    <v-checkbox
                      color="primary"
                      :label="$t(`table.hideAvatar`)"
                      hide-details
                      v-model="User.obj.isHideAvatar"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols :sm="4" class="pt-5">
                    <v-checkbox
                      color="primary"
                      :label="$t(`table.hideCover`)"
                      hide-details
                      v-model="User.obj.isHideCover"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols :sm="4" class="pt-5">
                    <v-checkbox
                      color="primary"
                      :label="$t(`table.kol`)"
                      hide-details
                      v-model="User.obj.isKol"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-row>
                  <v-col cols :sm="12" class="py-0">
                    <v-statusUser
                      v-model="User.obj.status"
                      :rules="[Rules.required]"
                    />
                  </v-col>
                  <v-col cols :sm="12" class="pt-5">
                    <v-textarea
                      color="primary"
                      v-model="User.obj.note"
                      rows="3"
                    >
                      <template #label>
                        {{ $t(`table.note`) }}
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="pt-5">
                <v-row>
                  <v-col cols :sm="12" class="py-0">
                    <v-textarea
                      color="primary"
                      v-model="User.obj.quote"
                      rows="3"
                      readonly
                    >
                      <template #label>
                        {{ $t(`table.quote`) }}
                      </template>
                    </v-textarea>
                  </v-col>
                  <v-col cols :sm="12" class="py-0">
                    <v-textarea
                      color="primary"
                      v-model="User.obj.story"
                      rows="3"
                      readonly
                    >
                      <template #label>
                        {{ $t(`table.story`) }}
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-row>
                  <v-col cols :sm="12" class="pt-5">
                    <v-textarea
                      color="primary"
                      v-model="User.obj.deletedReasons"
                      readonly
                      rows="3"
                    >
                      <template #label>
                        {{ $t(`table.deletedReasons`) }}
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
                <v-row v-if="User.obj.datingImages.length">
                  <v-col cols :sm="12" class="py-0">
                    <v-statusDating
                      v-model="User.obj.datingStatus"
                      :rules="[Rules.required]"
                    />
                  </v-col>
                  <v-col cols :sm="12" class="py-0 mb-3">
                    <div class="caption font-weight-bold">
                      {{ $t(`table.datingImages`) }}
                    </div>
                    <v-row
                      v-for="i in 2"
                      :key="User.obj.datingImages[i - 1].id"
                    >
                      <v-col cols :sm="6">
                        <v-upload
                          :width="60"
                          :height="80"
                          v-model="User.obj.datingImages[i - 1].link"
                          readonly
                        />
                      </v-col>
                      <v-col cols :sm="6">
                        <v-upload
                          :width="60"
                          :height="80"
                          v-model="User.obj.verifyImages[i - 1]"
                          readonly
                        />
                      </v-col>
                      <v-col class="px-3 py-0" :sm="12">
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols
                :sm="6"
                class="py-0"
                v-if="fnCheckMission(Session, [{ m: USER, p: 'root' }])"
              >
                <v-text-field
                  color="primary"
                  required
                  type="number"
                  :rules="[Rules.number]"
                  v-model="User.obj.numberOfCandy"
                >
                  <template #label>
                    {{ $t(`table.candy`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!User.isValid"
              @click="User.isCreate ? _fnCreate() : _fnUpdate()"
              >{{ User.isCreate ? $t(`table.create`) : $t(`table.update`) }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "User",
  }),
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    async _fnUpdate() {
      const { code } = await this.fnPut({
        url: `/v1/admin/user/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
  },
};
</script>
